var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMongoDb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 30,
    viewBox: "0 0 14 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 -0.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.88,32.665l-.832-.273s.1-4.071-1.421-4.363c-1.015-1.13.163-47.922,3.817-.156a2.9,2.9,0,0,0-1.482,1.636A14.421,14.421,0,0,0,10.88,32.665Z",
    transform: "translate(-3.169 -2.593)",
    fill: "#a6a385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M12.425,26.191a13.948,13.948,0,0,0,5.583-14.163C16.364,5.074,12.486,2.8,12.06,1.918A9.682,9.682,0,0,1,11.146.2l.3,19.344c0,.02-.629,5.922.975,6.643",
    transform: "translate(-4.267 -0.054)",
    fill: "#499d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M6.453,26.39S-.389,21.91.017,14.02A16.433,16.433,0,0,1,6.169,1.553,1.779,1.779,0,0,0,6.839.072c.426.877.345,13.11.406,14.552C7.427,20.176,6.92,25.339,6.453,26.39Z",
    transform: "translate(0)",
    fill: "#58aa50"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMongoDb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mongoDB.c43aba94f2110dc108444b36ad634001.svg";